import Vue from "vue";

Vue.filter("truncate", function(string)
{
    // eslint-disable-next-line no-unused-vars
    let url = string.replace("/[^a-zA-Z0-9-äöüÜÖÄß\-]/", "-");

    url = url.replace("/-+/", "-");
    url = url.toLowerCase;

    return url;
});
